// "Put another way" - fun real-terms comparison strip. Theme-aware throughout.
import { useState, useMemo } from 'react'
import { colors, fonts } from './UI'
import { pickComparisons, formatComparison } from '../lib/comparisons'

function rgba(hex, a) {
  const n = parseInt(hex.slice(1), 16)
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`
}

export default function SpendingInContext({ spend }) {
  const [seed, setSeed] = useState(0)
  const pick = useMemo(() => pickComparisons(spend, 4), [spend, seed])
  if (!pick) return null

  const hero = formatComparison(pick.hero, spend)

  return (
    <div style={{ background: colors.card, border: `1px solid ${colors.borderGold}`, borderRadius: '16px', boxShadow: `0 8px 24px rgba(0,0,0,0.32), 0 0 28px ${colors.cardGlow}`, backdropFilter: colors.cardBlur, WebkitBackdropFilter: colors.cardBlur, overflow: 'hidden', marginBottom: '14px' }}>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '15px 18px 6px' }}>
        <span style={{ fontFamily: fonts.heading, fontSize: '13px', fontWeight: 700, letterSpacing: '0.1em', color: `rgba(${colors.textRgb},0.7)` }}>PUT ANOTHER WAY</span>
        <button onClick={() => setSeed(s => s + 1)} style={{ display: 'flex', alignItems: 'center', gap: '5px', background: 'none', border: 'none', cursor: 'pointer', fontSize: '11px', fontWeight: 600, color: rgba(colors.gold, 0.9), fontFamily: fonts.body, padding: 0 }}>
          <span style={{ fontSize: '13px' }}>🎲</span> shuffle
        </button>
      </div>

      <div style={{ padding: '4px 18px 6px' }}>
        <p style={{ fontSize: '13px', lineHeight: 1.5, color: `rgba(${colors.textRgb},0.7)`, margin: '0 0 14px' }}>
          Your spending this period could have bought you:
        </p>

        {/* Hero */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '14px 16px', background: rgba(colors.gold, 0.08), borderRadius: '13px', marginBottom: '12px' }}>
          <span style={{ fontSize: '38px', lineHeight: 1 }}>{pick.hero.e}</span>
          <div>
            <div style={{ fontFamily: fonts.heading, fontSize: '32px', fontWeight: 700, color: colors.gold, lineHeight: 1 }}>{hero.big}</div>
            <div style={{ fontSize: '13px', fontWeight: 600, color: `rgba(${colors.textRgb},0.85)`, marginTop: '2px' }}>{hero.caption}</div>
          </div>
        </div>

        {/* Grid of alternates */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '9px' }}>
          {pick.items.map((it, i) => {
            const f = formatComparison(it, spend)
            return (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '11px 13px', background: `rgba(${colors.textRgb},0.03)`, border: '1px solid rgba(255,255,255,0.06)', borderRadius: '11px' }}>
                <span style={{ fontSize: '22px' }}>{it.e}</span>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontFamily: fonts.heading, fontSize: '18px', fontWeight: 700, color: colors.text, lineHeight: 1 }}>{f.big}</div>
                  <div style={{ fontSize: '11px', color: `rgba(${colors.textRgb},0.6)`, marginTop: '1px' }}>{f.caption}</div>
                </div>
              </div>
            )
          })}
        </div>
      </div>

      <div style={{ height: '16px' }} />
    </div>
  )
}
